export const INPUT_NO_FOCUS_HIGHLIGHT_CLASS =
  'focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:ring-transparent focus-visible:outline-none focus-visible:ring-opacity-0';
